export default __webpack_public_path__ + "static/media/distrito22arr.497dba0d.jpg";